const PORTRAIT_BREAKPOINTS = [0, 390, 428, 468, 580, 640, 840, 1023];
export {
  PORTRAIT_BREAKPOINTS
};
//# sourceMappingURL=constants.mjs.map
